module.exports = __webpack_public_path__ + "img/showcase-instaview-en-us.2627fad7.jpg";